export const bpmnRefreshTypes = {
  ELEMENTS: 'ELEMENTS',
  FLOW_GROUP: 'FLOW_GROUP'
}
